import { render, staticRenderFns } from "./PlatformPosts.vue?vue&type=template&id=77edc8b2&"
import script from "./PlatformPosts.vue?vue&type=script&lang=js&"
export * from "./PlatformPosts.vue?vue&type=script&lang=js&"
import style0 from "./PlatformPosts.vue?vue&type=style&index=0&id=77edc8b2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77edc8b2')) {
      api.createRecord('77edc8b2', component.options)
    } else {
      api.reload('77edc8b2', component.options)
    }
    module.hot.accept("./PlatformPosts.vue?vue&type=template&id=77edc8b2&", function () {
      api.rerender('77edc8b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/campaign/ViewCampaign/PlatformPosts.vue"
export default component.exports